var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 94,
    viewBox: "0 0 193 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.783 57.1223C196.698 30.6125 181.459 4.04238 160.364 2.45645C147.537 -2.47488 73.9435 6.728 37.3815 5.30345C0.81953 3.8789 21.7855 50.5377 8.22099 64.5254C-2.63065 75.7155 2.30512 91.0364 8.77705 92.0526C7.29954 88.175 14.602 67.8301 59.4078 66.5198C104.214 65.2095 184.868 83.6322 190.783 57.1223Z",
    stroke: "#834D8E",
    strokeWidth: 1.82184
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.1c00de0ce15cf972f04d1de1f9ca8c0f.svg";
export { ForwardRef as ReactComponent };